export default __webpack_public_path__ + "static/media/omidyar.16c0ac23.svg";